module.exports = __webpack_public_path__ + "img/register-bg.bf591bc4.png";